var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "header" },
    [
      _c(
        "header",
        {
          staticClass: "fixed w-100 brdr-bottom-0 bg-cl-primary",
          class: { "site-header--transformed": _vm.scrollTop > 20 }
        },
        [
          _c(
            "div",
            { class: _vm.headerBackground },
            [
              !_vm.isOffice()
                ? _c("shop-info", { class: _vm.classHeader })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "container-fluid main-top-header px15",
              staticStyle: { "box-sizing": "border-box" }
            },
            [
              _c("loader", { attrs: { isheader: true } }),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isCheckoutPage || _vm.isThankYouPage,
                      expression: "!isCheckoutPage || isThankYouPage"
                    }
                  ],
                  staticClass: "row between-xs middle-xs nav_rwd",
                  staticStyle: { height: "100%" }
                },
                [
                  _c("div", { staticClass: "col-md-9 col-xs-2 middle-xs" }, [
                    _c(
                      "div",
                      {
                        staticClass: "flex",
                        staticStyle: {
                          "align-items": "flex-start",
                          width: "100%"
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "pt5 px15 pointer hidden-xs" },
                          [
                            _c("logo", {
                              attrs: {
                                width: _vm.scrollTop > 20 ? "112px" : "144px",
                                height: "auto"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("hamburger-icon", {
                          staticClass:
                            "px5 py10 mx5 icon bg-cl-transparent pointer visible-xs"
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "inline-flex menu_position-rwd",
                            staticStyle: {
                              flex: "2",
                              "flex-wrap": "nowrap",
                              "padding-top": "6px"
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "inline-flex" },
                              _vm._l(_vm.visibleCategories(), function(
                                category
                              ) {
                                return _c(
                                  "button",
                                  {
                                    key: category.slug,
                                    staticClass:
                                      "menu-item relative desktop-only bg-cl-transparent brdr-none inline-flex hidden-xs",
                                    class: {
                                      "with-submenu":
                                        category.children_data &&
                                        category.children_data.length
                                    },
                                    attrs: { type: "button" },
                                    on: {
                                      mouseenter: function($event) {
                                        _vm.activeSubMenu = category.id
                                      },
                                      mouseleave: function($event) {
                                        _vm.activeSubMenu = null
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "menu-link main-menu-item",
                                        class: [
                                          {
                                            active:
                                              _vm.activeSubMenu ==
                                                category.id && !_vm.isOffice()
                                          },
                                          {
                                            active2:
                                              _vm.activeSubMenu ==
                                                category.id && _vm.isOffice()
                                          }
                                        ],
                                        attrs: {
                                          "aria-label": _vm.$t(
                                            "Show subcategories"
                                          ),
                                          "data-testid": category.id,
                                          to: _vm.localizedRoute({
                                            name: "category",
                                            params: {
                                              id: category.id,
                                              slug: category.url_path
                                            }
                                          })
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.toggleSubMenu(
                                              category.id
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(category.name))]
                                    ),
                                    _vm._v(" "),
                                    _c("sub-category", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.activeSubMenu === category.id,
                                          expression:
                                            "activeSubMenu === category.id"
                                        }
                                      ],
                                      attrs: {
                                        "category-links":
                                          category.children_data,
                                        id: category.id,
                                        "parent-slug": category.slug,
                                        "parent-name": category.name
                                      }
                                    })
                                  ],
                                  1
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "inline-flex" },
                              _vm._l(_vm.getCmsData(), function(
                                menuItem,
                                index
                              ) {
                                return _c(
                                  "button",
                                  {
                                    key: index,
                                    staticClass:
                                      "menu-item desktop-only relative bg-cl-transparent brdr-none inline-flex hidden-xs",
                                    attrs: { type: "button" },
                                    on: {
                                      mouseenter: function($event) {
                                        _vm.activeSubMenu = menuItem.displayName
                                      },
                                      mouseleave: function($event) {
                                        _vm.activeSubMenu = null
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "menu-link main-menu-item",
                                        class: [
                                          {
                                            active:
                                              _vm.activeSubMenu ==
                                                menuItem.displayName &&
                                              !_vm.isOffice()
                                          },
                                          {
                                            active2:
                                              _vm.activeSubMenu ==
                                                menuItem.displayName &&
                                              _vm.isOffice()
                                          }
                                        ],
                                        attrs: {
                                          href: _vm.getUrl(menuItem),
                                          target: _vm.getTarget(menuItem)
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(menuItem.displayName) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "col-xs-2 visible-xs",
                      staticStyle: { "padding-left": "0px" }
                    },
                    [
                      _c("search-icon", {
                        staticClass: "mb5 mx5 icon pointer header-icon-btn"
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-md-4 col-xs-4 center-xs mobi-logo visible-xs pt5",
                      staticStyle: {
                        "padding-left": "0px",
                        "padding-right": "10px"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "visible-xs" },
                        [
                          _c("logo", {
                            attrs: { width: "100%", height: "41px" }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-xs-2 visible-xs" },
                    [
                      _c("wishlist-icon", {
                        staticClass: "mb5 mx5 icon pointer header-icon-btn"
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-xs-2 visible-xs pr15" },
                    [
                      _c("microcart-icon", {
                        staticClass: "mb5 mx5 icon pointer header-icon-btn"
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-md-3 col-xs-2 end-xs hidden-xs" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "inline-flex right-icons pr15",
                          staticStyle: { "align-items": "center" }
                        },
                        [
                          _c("search-icon", {
                            staticClass:
                              "p10 mx5 icon hidden-xs pointer header-icon-btn",
                            class: _vm.headerIconBtn
                          }),
                          _vm._v(" "),
                          _c("wishlist-icon", {
                            staticClass:
                              "p10 mx5 icon hidden-xs pointer header-icon-btn",
                            class: _vm.headerIconBtn
                          }),
                          _vm._v(" "),
                          _c("microcart-icon", {
                            staticClass: "p10 mx5 icon pointer header-icon-btn",
                            class: _vm.headerIconBtn
                          }),
                          _vm._v(" "),
                          _c("account-icon", {
                            staticClass:
                              "mx5 icon hidden-xs pointer header-icon-btn",
                            class: _vm.headerIconBtn
                          })
                        ],
                        1
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isCheckoutPage && !_vm.isThankYouPage,
                      expression: "isCheckoutPage && !isThankYouPage"
                    }
                  ],
                  staticClass: "row between-xs middle-xs px15 py5 checkout"
                },
                [
                  _c("div", { staticClass: "col-xs-5 col-md-3 hidden-xs" }, [
                    _c(
                      "div",
                      [
                        _c(
                          "router-link",
                          {
                            staticClass:
                              "cl-white links py10 px20 bg-cl-mine-shaft checkout-links",
                            attrs: { to: _vm.localizedRoute("/") }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("Return to shopping")) +
                                "\n            "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-xs-5 col-md-6 center-xs mobi-logo" },
                    [_c("logo", { attrs: { width: "104px", height: "41px" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-xs-7 col-md-3 end-xs" }, [
                    _c("div", [
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.currentUser,
                              expression: "!currentUser"
                            }
                          ],
                          staticClass:
                            "cl-white links py10 px20 bg-cl-mine-shaft checkout-links",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.gotoAccount($event)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Login to your account")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.currentUser,
                              expression: "currentUser"
                            }
                          ]
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "You are logged in as {firstname}",
                                _vm.currentUser
                              )
                            )
                          )
                        ]
                      )
                    ])
                  ])
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("social-links"),
      _vm._v(" "),
      _c("div", {
        staticClass: "header-placeholder",
        class: { "site-header--transformed": _vm.scrollTop > 20 }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }